// Configuración de alineaciones por tiempo (fútbol sala y volley).
// El resto de deportes no tienen esta funcionalidad todavía.

export const JUGADORES_EN_PISTA_FUTSAL = 5;

// Slots fijos de la formación estándar de fútbol sala (1 portero + 4 jugadores
// de pista). x/y son porcentajes dentro del medio campo dibujado, con la
// portería propia a la izquierda (x=0) y la línea de medio campo a la
// derecha (x=100).
export const SLOTS_FUTSAL = [
  { id: "portero", label: "Portero", x: 8, y: 50 },
  { id: "cierre", label: "Cierre", x: 30, y: 50 },
  { id: "ala_1", label: "Ala", x: 58, y: 18 },
  { id: "ala_2", label: "Ala", x: 58, y: 82 },
  { id: "pivot", label: "Pívot", x: 85, y: 50 },
];

// Nº de tiempos según categoría (reglamento fútbol sala base).
export const TIEMPOS_POR_CATEGORIA_FUTSAL = {
  Prebenjamín: 2,
  Benjamín: 2,
  Alevín: 2,
  Infantil: 2,
  Cadete: 4,
  Juvenil: 4,
  Senior: 4,
};

export const esFutsal = (deporte) => deporte === "futbol sala";

export const numTiemposPorDefecto = (categoria) => TIEMPOS_POR_CATEGORIA_FUTSAL[categoria] || 2;

export const esVolley = (deporte) => deporte === "volley";

// Coordenadas pensadas para la orientación vertical (red arriba, fondo de la
// pista abajo, como se ve en móvil). En horizontal (escritorio) se transponen
// intercambiando x/y para que la red quede a la izquierda.
export const SLOTS_VOLLEY_6 = [
  { id: "del_izq", label: "Delantero Izq.", x: 20, y: 20 },
  { id: "del_centro", label: "Delantero Centro", x: 50, y: 20 },
  { id: "del_der", label: "Delantero Der.", x: 80, y: 20 },
  { id: "zag_izq", label: "Zaguero Izq.", x: 20, y: 78 },
  { id: "zag_centro", label: "Zaguero Centro", x: 50, y: 78 },
  { id: "zag_der", label: "Zaguero Der.", x: 80, y: 78 },
];

// Formación 1-2-1 (diamante): 1 delantero centro pegado a la red, 2 medios
// en los laterales y 1 zaguero centro al fondo de la pista.
export const SLOTS_VOLLEY_4 = [
  { id: "del_centro", label: "Delantero Centro", x: 50, y: 18 },
  { id: "medio_izq", label: "Medio Izq.", x: 25, y: 50 },
  { id: "medio_der", label: "Medio Der.", x: 75, y: 50 },
  { id: "zag_centro", label: "Zaguero Centro", x: 50, y: 82 },
];

export const MODO_VOLLEY_POR_DEFECTO = 6;

export const slotsVolley = (modoVolley) =>
  Number(modoVolley) === 4 ? SLOTS_VOLLEY_4 : SLOTS_VOLLEY_6;
